<ng-container *transloco="let tNewWorkspace; read: 'new_workspace'">
    <app-modal-layout
        [containerLayout]="containerLayout"
        [errors]="errors"
        [showLoader]="showLoader"
        (closeModal)="forceWithValidation()"
    >
        <ng-container title>{{
            data ? tNewWorkspace('manage_workspace') : tNewWorkspace('create_new_workspace')
        }}</ng-container>

        <div>
            <div class="mb-6 mt-4 min-w-[28rem]">
                <div class="mb-1 text-text">{{ tNewWorkspace('workspace_name') }}</div>
                <app-tb-input
                    *transloco="let tCommonErrors; read: 'common_errors'"
                    [autofocus]="true"
                    [formControl]="workspaceGroupControl.controls['name']"
                    [errors]="[
                        { code: 'required', message: tNewWorkspace('incorrect_input') },
                        { code: 'pattern', message: tCommonErrors('name_whitespace_input') },
                    ]"
                ></app-tb-input>
            </div>
            <div class="flex justify-between gap-4 w-full mb-6">
                <app-color-picker
                    name="Color"
                    [set]="SetType.WORKSPACE"
                    class="w-full"
                    [color]="defaultColor"
                    [subtitle]="data ? data.workspace.name.value : ''"
                    (colorChange)="updateColor($event)"
                ></app-color-picker>
                <app-icon-picker
                    name="Icon"
                    class="w-full"
                    [set]="SetType.WORKSPACE"
                    [icon]="defaultIcon"
                    [iconColor]="color ?? defaultColor"
                    [subtitle]="data ? data.workspace.name.value : ''"
                    (iconChange)="updateIcon($event)"
                ></app-icon-picker>
            </div>
            <app-access-selector
                *appEnv="'prod'; visible: false"
                class="mb-10"
            ></app-access-selector>
            @if (!data) {
                <app-advanced-options
                    [schemaTabs]="schemaTabs()!"
                    [templateViews]="templateViews"
                    [templateSchemas]="templateSchemas"
                    [fieldsBySchema]="templateFields"
                    (inactiveFieldsChange)="inactiveFields = $event"
                    (templateSchemasChange)="templateSchemas = $event"
                    (templateViewsChange)="templateViews = $event"
                    (fieldsBySchemaChange)="templateFields = $event"
                ></app-advanced-options>
            }
        </div>

        <ng-container buttons *transloco="let tButtons; read: 'buttons'">
            <app-modal-layout-buttons
                [action]="data && !isGlobal"
                [primary]="true"
                [cancel]="true"
                [primaryLonger]="true"
            >
                @if (data && !isGlobal) {
                    <app-tb-button
                        action
                        [appearance]="isTablet ? 'outlined' : 'text'"
                        color="secondary"
                        icon="close"
                        (click)="delete()"
                        class="whitespace-nowrap min-w-[6.25rem]"
                    >
                        <span class="body-2">{{ tButtons('delete') }}</span>
                    </app-tb-button>
                }
                <app-tb-button
                    cancel
                    (click)="close()"
                    class="flex-1 sm:flex-none min-w-[6.25rem]"
                    appearance="outlined"
                >
                    {{ tButtons('cancel') }}
                </app-tb-button>
                <div primary class="flex sm:gap-1 gap-2 flex-1 sm:flex-none">
                    <app-tb-button class="w-full min-w-[6.25rem]" (click)="apply()">{{
                        tButtons(!data ? 'create' : 'save')
                    }}</app-tb-button>
                    <app-tb-button
                        *appEnv="'prod'; visible: false"
                        appearance="iconPrimary"
                        icon="expand_less"
                    >
                    </app-tb-button>
                </div>
            </app-modal-layout-buttons>
        </ng-container>
    </app-modal-layout>
</ng-container>
